import React, { useCallback, useEffect, useState } from 'react';
import { Step, Stepper, StepLabel, Container, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { pdfjs } from 'react-pdf';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import AggrementAddStep1 from './AddEditForm/AggrementAddStep1';
import AggrementAddStep2 from './AddEditForm/AggrementAddStep2';
import AggrementAddStep3 from './AddEditForm/AggrementAddStep3';
import AggrementAddStep4 from './AddEditForm/AggrementAddStep4';
import AggrementAddStep5 from './AddEditForm/AggrementAddStep5';
import AggrementAddStep6 from './AddEditForm/AggrementAddStep6';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';
import { getAgreemetEditData, setAgreementEdit } from '../../store/Slice/Agreement/AgreementSlice';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function AddAgreement() {
  const [activeStep, setActiveStep] = useState(0);
  const [reviewData, setReviewData] = useState({});

  const location = useLocation();
  const dispatch = useDispatch();
  const { rowId } = location?.state || {};

  const { LoginData } = useLoginSelector();
  const authReviewData = JSON.parse(localStorage.getItem('reviewData'));

  const handlePrev = () => {
    setActiveStep((activeStep) => activeStep - 1);
  };

  const getAgreementEditApi = useCallback(() => {
    if (location.pathname === '/agreement/edit' && rowId && LoginData && authReviewData === null) {
      const credential = {
        aggrementId: rowId,
        companyId: LoginData?.companyId,
        userId: LoginData?.userId
      };
      dispatch(getAgreemetEditData(credential));
    } else {
      dispatch(setAgreementEdit(null)); // store in redux
    }
  }, [rowId, LoginData]);

  useEffect(() => {
    getAgreementEditApi();
  }, [getAgreementEditApi]);

  useEffect(() => {
    if (authReviewData !== null) {
      setReviewData(authReviewData);
    }
  }, []);

  return (
    <Page title="Partner Managemet System || Agreement">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            className="pageHeading"
          >
            {location.pathname === '/agreement/add' ? (
              <PageTitle info="Add New Agreement" />
            ) : (
              <PageTitle info="Edit Agreement" />
            )}
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Stepper
            connector=""
            activeStep={activeStep}
            sx={{ marginBottom: '25px' }}
            className="stepWizardOuter"
          >
            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Add Bank</StepLabel>
            </Step>

            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Add Branch</StepLabel>
            </Step>

            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Upload Agreement</StepLabel>
            </Step>

            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Add Commission</StepLabel>
            </Step>

            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Add Billing</StepLabel>
            </Step>

            <Step className="stepWizard" sx={{ mr: '0!important' }}>
              <StepLabel className="stepWizardLabel">Review</StepLabel>
            </Step>
          </Stepper>
          {activeStep === 0 ? (
            <AggrementAddStep1
              setActiveStep={setActiveStep}
              reviewData={reviewData}
              setReviewData={setReviewData}
            />
          ) : activeStep === 1 ? (
            <AggrementAddStep2
              handlePrev={handlePrev}
              setActiveStep={setActiveStep}
              reviewData={reviewData}
              setReviewData={setReviewData}
            />
          ) : activeStep === 2 ? (
            <AggrementAddStep4
              handlePrev={handlePrev}
              setActiveStep={setActiveStep}
              reviewData={reviewData}
              setReviewData={setReviewData}
            />
          ) : activeStep === 3 ? (
            <AggrementAddStep3
              handlePrev={handlePrev}
              setActiveStep={setActiveStep}
              reviewData={reviewData}
              setReviewData={setReviewData}
            />
          ) : activeStep === 4 ? (
            <AggrementAddStep6
              handlePrev={handlePrev}
              setActiveStep={setActiveStep}
              reviewData={reviewData}
              setReviewData={setReviewData}
            />
          ) : (
            <AggrementAddStep5 handlePrev={handlePrev} reviewData={reviewData} />
          )}
        </Box>
      </Container>
    </Page>
  );
}

export default AddAgreement;
